// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfiniteUploadIcon__icon-eddc96 {
  flex-shrink: 0;
  vertical-align: middle;
  fill: currentColor;
  cursor: pointer;
}

.InfiniteUploadIcon__icon-eddc96 circle {
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 2px;
  animation: InfiniteUploadIcon__dash-a240ae 1.5s ease-in-out infinite, InfiniteUploadIcon__rotate-eb3cd6 2s linear infinite;
  transform-origin: center;
  transform-box: fill-box;
}

@keyframes InfiniteUploadIcon__rotate-eb3cd6 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes InfiniteUploadIcon__dash-a240ae {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/components/InfiniteUploadIcon/InfiniteUploadIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0HAAA;EACA,wBAAA;EACA,uBAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,wBAAA;IACA,oBAAA;EAAF;EAEA;IACE,yBAAA;IACA,sBAAA;EAAF;EAEA;IACE,yBAAA;IACA,uBAAA;EAAF;AACF","sourcesContent":[".icon {\n  flex-shrink: 0;\n  vertical-align: middle;\n  fill: currentColor;\n  cursor: pointer;\n}\n\n.icon circle {\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 2px;\n  animation: dash 1.5s ease-in-out infinite, rotate 2s linear infinite;\n  transform-origin: center;\n  transform-box: fill-box;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `InfiniteUploadIcon__icon-eddc96`,
	"dash": `InfiniteUploadIcon__dash-a240ae`,
	"rotate": `InfiniteUploadIcon__rotate-eb3cd6`
};
module.exports = ___CSS_LOADER_EXPORT___;
